import { mapState } from 'vuex'
export const storeState = {
  computed: {
    ...mapState({
      customer: (state) => state.customer,
      business: (state) => state.business,
      stock: (state) => state.stock,
      currency: (state) => state.currency,
      employee: (state) => state.employee,
      supply: (state) => state.supply,
      payment: (state) => state.payment,
      category: (state) => state.category,
    }),
  },
}
